module.exports = __webpack_public_path__ + "static/media/bahai.c30ed991.svg";